"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Tournament_1 = __importDefault(require("./Tournament"));
var DailySlider_1 = __importDefault(require("../DailySlider"));
var next_intl_1 = require("next-intl");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var Tournaments = function (_a) {
    var pointsToNextLevel = _a.pointsToNextLevel, closeDigest = _a.closeDigest;
    var t = (0, next_intl_1.useTranslations)('translation');
    var _b = (0, swr_hooks_1.useActiveTournaments)(), data = _b.data, isLoading = _b.isLoading;
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, t('tournaments')),
        react_1.default.createElement("div", null, isLoading ? (react_1.default.createElement(ui_components_1.LoadingWithContainer, null)) : (react_1.default.createElement(react_1.default.Fragment, null, !data || data.length === 0 ? (react_1.default.createElement("div", { className: styles_module_scss_1.default.notAvailableTournaments }, t('notAvailableTournaments'))) : (react_1.default.createElement(DailySlider_1.default, { Card: Tournament_1.default, items: data, additionalProps: { pointsToNextLevel: pointsToNextLevel, closeDigest: closeDigest } })))))));
};
exports.default = react_1.default.memo(Tournaments);
